// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const TouchSessions: React.FC = () => {
  const {
    data: { totalTouchSessions },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, totalTouchSessions, startDate, endDate);

  return (
    <>
      {totalTouchSessions && chartData.length > 0 && (
      <LineChart
        theme="blue"
        title="Touchscreen Sessions"
        subtitle="Amount started sessions. One session can be converted to one user."
        label="Sessions"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
